<section class="admin-users">

  <div class="admin-users__toolbar">
    <button type="button" class="btn btn--primary btn--sm" data-id="btn-new-admin">
      <i class="icon icon--plus"></i> <%= _lcs( 'Neuen Admin anlegen' ) %>
    </button>
  </div>

  <!-- Grid (or loading / empty / error message) is rendered here by AdminUser.js -->
  <div class="admin-users__state" data-id="users-state"></div>

  <!-- Create / edit modal (web component) -->
  <admin-user-form data-id="admin-form"></admin-user-form>

  <!-- Read-only details modal (web component) -->
  <admin-user-detail data-id="admin-detail"></admin-user-detail>

</section>
